import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default ({ icon, name, children, ...rest }) => <FontAwesomeIcon icon={icon || name || children} {...rest} />;
